import { useHTTP, useHTTPMutation, type HTTPResponse } from "@/lib/http";
import type { MutationFunction } from "@tanstack/react-query";

export interface PushAppLoadRequestModel {
	readonly attribution: string | null;
}

export const usePushAppLoad = () => {
	const http = useHTTP("Required");

	const mutationFn: MutationFunction<HTTPResponse, PushAppLoadRequestModel> = requestModel => {
		return http<undefined, PushAppLoadRequestModel>({
			method: "POST",
			url: "/analytics/app-load",
			body: requestModel
		});
	};

	return useHTTPMutation({ mutationFn });
};
